// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoriaLinkCard_root__aZi71","title":"CategoriaLinkCard_title__UD1Ti","imageBox":"CategoriaLinkCard_imageBox__z876P","rotation":"CategoriaLinkCard_rotation__tOBe3"};